/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;



//////////////////
// WEBPACK FOOTER
// ./~/velocity-react/~/lodash/_freeGlobal.js
// module id = 1425
// module chunks = 4